<template>
    <div class="card-body row m-0" v-if="!medicalReportLoading">
        <div class="col-sm-6">

          <template v-if="clientAnamnesis !== false">
            <anamnesis-editor v-for="ca in clientAnamnesis" :anamnesis="ca" :force-save="forceSave" @saved="anamnesisSaved">

            </anamnesis-editor>

          </template>

          <template>
            <a class="btn btn-sm btn-success" target="_blank" role="button" data-testid="visit-medical-report-print" :href="hostname.hostname + 'visit/' + $route.params.visitid + '/medical_report/pdf'">
              <i class="fa fa-print"></i> Tisknout zprávu
            </a>
          </template>

          <template v-if="medicalReportText !== ''">
            <div class="card" data-testid="visit-medical-report-existing">
              <div class="card-header">Stará lékařská zpráva</div>
              <div class="card-body" v-html="medicalReportText"></div>
            </div>
          </template>

        </div>
        <div class="col-sm-6">
            <table class="table" data-testid="visit-medical-report-history">
                <thead>
                <tr class="row m-0">
                    <th class="col-sm-1">

                    </th>
                    <th class="col-sm-3">Datum</th>
                    <th class="col-sm-3">Typ</th>
                    <th class="col-sm-5"></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(task, index) in tasks" class="card-text">
                    <tr class="row m-0" :class="openedTaskId === index ? 'border border-primary border-bottom-0' : ''" :data-testid="'visit-medical-report-history-row-' + index">
                        <td class="align-middle col-sm-1">
                            <button class="btn btn-sm btn-primary" @click="openTaskId(index, task)" v-if="openedTaskId === index" :data-testid="'visit-medical-report-history-toggle-' + index">-</button>
                            <button class="btn btn-sm btn-secondary" @click="openTaskId(index, task)" v-else="" :data-testid="'visit-medical-report-history-toggle-' + index">+</button>
                            <!-- <visit-change-state v-on:update="getDoctorsDayTasks" :actual-state="task.state" :selected-doctor-id="task.planned_for.id" :visit-id="task.id"></visit-change-state> -->
                        </td>
                        <td class="col-sm-3">{{ task.date_cs }}</td>
                        <td class="col-sm-3">
                            <span v-if="task.type === 'lab_result'"><i class="fa fa-flask fa-lg" aria-hidden="true"></i> Laboratorní výsledek</span>
                            <span v-else=""><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Lékařská zpráva</span>
                        <td class="col-sm-5"></td>
                    </tr>
                    <tr class="row m-0 border border-primary border-top-0" v-if="openedTaskId === index" :data-testid="'visit-medical-report-history-detail-' + index">
                        <td class="col-md-12" v-if="task.type === 'lab_result'">
                            <b>Laboratorní výsledek</b><br>
                            <div style="white-space: pre-wrap; font-family: monospace, monospace;" class="p-4" id="result_text" v-html="task.result">

                            </div>
                            <b>Hodnocení</b><br>
                            <div style="white-space: pre-wrap; font-family: monospace, monospace;" class="p-4" id="result_text" v-html="task.evaluation">

                            </div>
                        </td>
                        <td class="col-md-12" v-else="">
                            <b>Lékařská zpráva</b> <button class="btn btn-sm btn-primary" :data-testid="'visit-medical-report-history-copy-' + index" @click="copyAndInsertReport(task.text)">Zkopírovat</button><br>
                            <div style="white-space: pre-wrap; font-family: monospace, monospace;" class="p-4" id="result_text" v-html="task.text">

                            </div>
                            <template v-if="task.visit">
                                <div class="">
                                    <h6>Diagnózy a výkony</h6>
                                    <div>
                                        <table class="table">
                                            <tbody>
                                            <template v-for="diagnose in task.visit.diagnosis">
                                                <tr>
                                                    <td>{{ diagnose.disease.code }}</td>
                                                    <td>{{ diagnose.disease.name_cs }}</td>
                                                </tr>
                                                <template v-if="diagnose.actions.length > 0">
                                                    <template v-for="action in diagnose.actions">
                                                        <tr>
                                                            <td></td>
                                                            <td>
                                                                {{ action.operation.code }} - {{ action.operation.name }}
                                                            </td>
                                                        </tr>
                                                        <template v-if="action.zulp.length > 0">
                                                            <tr v-for="zulp in action.zulp">
                                                                <td></td>
                                                                <td>
                                                                    &nbsp;&nbsp;&nbsp;zulp: {{ zulp.amount }}x {{ zulp.medicine.label }}
                                                                </td>
                                                            </tr>
                                                        </template>
                                                        <template v-if="action.zum.length > 0">
                                                            <tr v-for="zum in action.zum">
                                                                <td></td>
                                                                <td>
                                                                    &nbsp;&nbsp;&nbsp;zum: {{ zum.amount }}x {{ zum.material.label }}
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-else="">
                                                    <tr>
                                                        <td></td>
                                                        <td>
                                                            <i>(diagnóza nemá přidělené výkony)</i>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="">
                                    <h6>Léčiva</h6>
                                    <div>
                                        <template v-if="task.visit.medicament.length > 0">
                                            <table class="table">
                                                <tbody>
                                                <tr v-for="m in task.visit.medicament">
                                                    <td>{{ m.medicine ? m.medicine.label : '' }} {{ m.individual_medicine ? m.individual_medicine.name : '' }}</td>
                                                    <td>{{ m.dosage }}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </template>
                                        <template v-else="">
                                            <i>žádný lék nepředepsán</i>
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </td>
                    </tr>

                </template>
                </tbody>
            </table>
        </div>
     </div>
</template>

<script>
  import apiMixin from '@/mixins'
  import MedicalReport from './MedicalReport.vue'
  import AnamnesisEditor from './AnamnesisEditor.vue'

  export default {
    data () {
      return {
        hostname: require('@/variables.js'),
        // customToolbar: [
        //   ['bold', 'italic', 'underline', 'strike'],
        //   [{'list': 'ordered'}, {'list': 'bullet'}],
        //   [{'indent': '-1'}, {'indent': '+1'}],
        //   [{'color': []}],
        //   [{'align': []}]
        // ],
        customToolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{'indent': '-1'}, {'indent': '+1'}]
        ],
        editorSettings: {
          modules: {
            keyboard: {
              bindings: {
                tab: {
                  key: 9,
                  handler: function (range, context) {
                    // console.log(document.activeElement)
                    // console.log('mackam tab')
                  }
                },
                'remove tab': {
                  key: 9,
                  shiftKey: true,
                  collapsed: true,
                  prefix: /\t$/,
                  handler: function () {
                    // console.log('mackam remove tab')
                  }
                }
              }
            }
          }
        },
        medicalReportText: '',
        medicalReportOldText: false,
        medicalReportLoading: false,
        medicalReportPending: false,
        medicalReportError: false,
        medicalReportChanged: false,
        //
        tasks: false,
        tasksError: false,
        tasksPending: true,
        openedTaskId: false,
        //
        clientAnamnesis: false,
        clientAnamnesisError: false,
        clientAnamnesisPending: false,
        clientAnamnesisDone: false,
        //
        editingAnamneses: [],
        //
        forceSaveAnamneses: [
          //
        ],
        forceSave: []
      }
    },
    mixins: [apiMixin],
    methods: {
      openTaskId (num, result) {
        if (this.openedTaskId === num) {
          this.openedTaskId = false
        } else {
          this.openedTaskId = num
        }
      },
      saveMedicalReport () {
        this.postMedicalReport(this.$route.params.visitid, this.medicalReportText)
      },
      copyAndInsertReport (report) {
        this.clientAnamnesis[0].text = report
      },
      editAnamnesis (identifier) {
        if (this.isEditingAnamnesis(identifier) === false) {
          this.editingAnamneses.push(identifier)
        }
      },
      isEditingAnamnesis (identifier) {
        for (var i = 0; i < this.editingAnamneses.length; i++) {
          if (this.editingAnamneses[i] === identifier) {
            return true
          }
        }
        return false
      },
      anamnesisSaved (id) {
        let index = this.forceSave.indexOf(id)
        if (index > -1) {
          this.forceSave.splice(index, 1)
        }
      }
    },
    beforeMount () {
      this.getMedicalReport(this.$route.params.visitid)
      this.getMedicalReportAndLabResultOfClient(this.$store.state.clientId, this.$route.params.visitid)
      this.getClientAnamnesisByVisit(this.$route.params.visitid)
    },
    watch: {
      '$route' (to, from) {
        if (to.params.visitid !== from.params.visitid) {
          this.getMedicalReport(this.$route.params.visitid)
          this.getMedicalReportOfClient(this.$store.state.clientId)
          this.getClientAnamnesisByVisit(this.$route.params.visitid)
          this.isChanged = false
          this.getVisit()
        }
      },
      // medicalReportText: _.debounce(function (newVal) {
      //   this.saveMedicalReport()
      // }, 1000),
      clientAnamnesisDone (val) {
        if (val === true) {
          this.$nextTick(function () {
            let that = this
            let elements = document.getElementsByClassName('anamnesisBlock')
            for (let i = 0; i < elements.length; i++) {
              let toolbarNode = elements[i].children[0].children[0]
              let newNode = document.createElement('div')
              newNode.className = 'anamnesisTitle'
              newNode.innerText = elements[i].getAttribute('data-anamnesis-text')
              elements[i].children[0].insertBefore(newNode, toolbarNode)
              elements[i].children[0].getElementsByClassName('ql-editor')[0].addEventListener('focus', function (e) {
                for (let j = 0; j < elements.length; j++) {
                  elements[j].classList.remove('focused')
                }
                // focusing
                elements[i].classList.add('focused')
              })
              elements[i].addEventListener('blur', function (e) {
                // defocusing
                elements[i].classList.remove('focused')
              })
              elements[i].children[0].getElementsByClassName('ql-editor')[0].addEventListener('blur', function (e) {
                that.forceSave.push(elements[i].id)
              })
              elements[i].children[0].getElementsByClassName('ql-editor')[0].addEventListener('keydown', function (e) {
                if (e.keyCode === 9 && i !== (elements.length - 1)) {
                  // force save leaving anamnesis
                  // that.forceSave.push(elements[i].id)
                  // defocus
                  elements[i].classList.remove('focused')
                  // focusing next element on tab key
                  let inputToFocus = elements[i + 1].children[0].getElementsByClassName('ql-editor')[0]
                  inputToFocus.focus()

                  // workaround to get cursor to the end of "textarea"
                  let range
                  let selection
                  if (document.createRange) {
                    range = document.createRange()
                    range.selectNodeContents(inputToFocus)
                    range.collapse(false)
                    selection = window.getSelection()
                    selection.removeAllRanges()
                    selection.addRange(range)
                  } else if (document.selection) {
                    range = document.body.createTextRange()
                    range.moveToElementText(inputToFocus)
                    range.collapse(false)
                    range.select()
                  }
                }
              })
            }

            document.getElementById('anamnesisNO').children[0].focus()
          }, this)
        }
      }
    },
    components: {
      AnamnesisEditor,
      MedicalReport
    },
    beforeRouteLeave (to, from) {
      this.saveMedicalReport()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Visit/components/MedicalReportNew.vue?72d41e5b